import classNames from 'classnames';
import React from 'react';
import { HasClassName } from '../component-utils';
import { QueueIconEnum } from '../model';
import { useCompactView } from './compactView';
import { ReactComponent as AlertIcon } from './icons/queue/alert.svg';
import { ReactComponent as ClosedIcon } from './icons/queue/closed.svg';
import { ReactComponent as EmergencyIcon } from './icons/queue/emergency.svg';
import { ReactComponent as HolidayIcon } from './icons/queue/holiday.svg';
import { ReactComponent as NoAgentsIcon } from './icons/queue/no-agents.svg';
import { ReactComponent as OpenIcon } from './icons/queue/open.svg';
import { ReactComponent as VirtualIcon } from './icons/queue/virtual.svg';
import { ReactComponent as WarningIcon } from './icons/queue/warning.svg';
import './QueueIcon.scss';

interface Props extends HasClassName {
  icon: QueueIconEnum
}

export default function QueueIcon({ className, icon }: Props) {
  const compact = useCompactView()
  return React.cloneElement(getIcon(icon), { className: classNames('QueueIcon', className, compact && 'compact-view') });
}

function getIcon(icon: QueueIconEnum) {
  switch (icon) {

    case QueueIconEnum.Closed:
      return <ClosedIcon />;
    case QueueIconEnum.Holiday:
      return <HolidayIcon />;
    case QueueIconEnum.Open:
      return <OpenIcon />;
    case QueueIconEnum.Virtual:
      return <VirtualIcon />;
    case QueueIconEnum.NoAgents:
      return <NoAgentsIcon />;
    case QueueIconEnum.Emergency:
      return <EmergencyIcon />;
    case QueueIconEnum.OpenWarning:
      return <WarningIcon />;
    case QueueIconEnum.OpenAlert:
      return <AlertIcon />;
    default:
      console.error('Unknown icon ' + icon);
      return <></>
  }
}
